import React, { Component } from 'react'
import { Translate, withLocalize } from 'react-localize-redux';
import { validateField, isSmartField } from '../../../utils/index.jsx';
import FieldSherwood from '../../general/FieldSherwood';
import Modal from '../../general/modal';
import Form from '../../general/form';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { ButtonAdd, ButtonSave, ButtonCancel } from '../../general/mini_components';
import { Grid, Typography } from "@mui/material";
import PropTypes from 'prop-types';
import OrderableTable from '../../general/OrderableTable';
import { MEDICAL_HISTORY_FIELDS } from '../../../constants';

const FIELD_GROUP_FORM = {
    "name": {
        required: true,
        type: "text",
        label: "investigation.create.edc.field_group.name",
        shortLabel: "investigation.table.name",
        validation: "textMin2"
    },
    "description": {
        required: false,
        type: "text",
        label: "investigation.create.edc.field_group.description",
        shortLabel: "investigation.create.edc.field_group.description",
        validation: "notEmpty"
    },
    "repeats": {
        required: false,
        type: "checkbox",
        label: "investigation.create.edc.field_group.repeats",
        shortLabel: "investigation.create.edc.field_group.repeats",
        validation: "notEmpty"
    },
    "displayMode": {
        required: false,
        type: "select",
        label: "investigation.create.edc.field_group.display_mode",
        shortLabel: "investigation.create.edc.field_group.display_mode",
        validation: "notEmpty",
        defaultOption: { text: "Inline", value: "inline" },
        options: [
            { label: "Inline", value: "inline" },
            { label: "Modal (Popup)", value: "modal" },
            { label: "Collapsible", value: "collapsible" }
        ]
    }
}

/**
 * A FieldGroup manages a group of fields within a section.
 * Groups can repeat and have their own display mode.
 */
class FieldGroup extends Component {
    constructor(props) {
        super(props);

        this.handleAddField = this.handleAddField.bind(this);
        this.toogleField = this.toogleField.bind(this);
        this.renderFields = this.renderFields.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.deleteField = this.deleteField.bind(this);
        this.getFormSection = this.getFormSection.bind(this);
        this.handleSaveFieldGroup = this.handleSaveFieldGroup.bind(this);

        const initialState = { addingField: false, fields: [], showTextarea: false, selectedType: '', forwardedFromSet: false };
        if (props.initialData) {
            this.state = Object.assign({}, initialState, {
                fields: props.initialData.fields || [],
                showTextarea: false,
                addingField: false,
                selectedType: '',
                forwardedFromSet: false
            });
        } else {
            this.state = initialState;
        }
    }

    getFormSection() {
        let FORM = {
            "encrypted": {
                name: "encrypted",
                required: false,
                type: "checkbox",
                label: "investigation.create.edc.personal_info",
                shortLabel: "investigation.table.is_personal_data",
                validation: "notEmpty"
            },
            "required": {
                name: "required",
                required: false,
                type: "checkbox",
                label: "investigation.create.edc.required",
                shortLabel: "investigation.table.required",
                validation: "notEmpty"
            },
            "name": {
                name: "name",
                required: true,
                type: "text",
                label: "investigation.create.edc.name_field",
                shortLabel: "investigation.table.name",
                validation: "textMin2"
            },
            "type": {
                name: "type",
                required: true,
                type: "select",
                validation: "notEmpty",
                label: "investigation.create.edc.choose",
                shortLabel: "investigation.table.type",
                defaultOption: { "text": "investigation.create.edc.choose", "value": "" },
                options: [
                    { "label": "investigation.create.edc.type_time", "value": "time" },
                    { "label": "investigation.create.edc.type_text", "value": "text" },
                    { "label": "investigation.create.edc.type_number", "value": "number" },
                    { "label": "investigation.create.edc.checkbox", "value": "checkbox" },
                    { "label": "investigation.create.edc.type_date", "value": "date" },
                    { "label": "investigation.create.edc.textarea", "value": "textarea" },
                    { "label": "investigation.create.edc.dropdown", "value": "select" },
                    { "label": "investigation.create.edc.multioption", "value": "multioption" },
                    { "label": "investigation.create.edc.autocomplete", "value": "autocomplete" },
                    { "label": "investigation.create.edc.radio", "value": "radio" },
                    { "label": "investigation.create.edc.evaluation", "value": "evaluation" },
                    { "label": "investigation.create.edc.diagnosis", "value": "icd" },
                    { "label": "investigation.create.edc.treatment", "value": "treatment" },
                    { "label": "investigation.create.edc.treatment_inpatient", "value": "treatment_inpatient" },
                    { "label": "investigation.create.edc.treatment_prescription", "value": "treatment_prescription" },
                    { "label": "investigation.create.edc.treatment_regular", "value": "treatment_regular" },
                    { "label": "investigation.create.edc.allergy", "value": "allergy" },
                    { "label": "investigation.create.edc.background", "value": "background" },
                    { "label": "investigation.create.edc.files", "value": "file" },
                    { "label": "investigation.create.edc.family-background", "value": "family-background" },
                    { "label": "investigation.create.edc.separator", "value": "separator" },
                    { "label": "investigation.create.edc.text_blob", "value": "text_blob" },
                    { "label": "investigation.create.edc.bmi", "value": "bmi" },
                    { "label": "investigation.create.edc.edd", "value": "edd" },
                    { "label": "investigation.create.edc.request_lab", "value": "request_lab" },
                    { "label": "investigation.create.edc.request_img", "value": "request_img" },
                    { "label": "investigation.create.edc.medical_history_ai", "value": "medical_history_ai" },
                    { "label": "investigation.create.edc.medical_history_template", "value": "medical_history_template" },
                    { "label": "investigation.create.edc.medical_history_template_fill", "value": "medical_history_template_fill" },
                    { "label": "investigation.create.edc.appointment", "value": "appointment" },
                    { "label": "investigation.create.edc.template_medical_history", "value": "template_medical_history" },
                ],
                callBackOnChange: (optionSeleced) => {
                    console.log("Call back on change", optionSeleced);
                    const tempState = { ...this.state, selectedType: optionSeleced };
                    if (MEDICAL_HISTORY_FIELDS.includes(optionSeleced)) {
                        tempState.showTextarea = true;
                    }
                    this.setState(tempState);
                },
                activationValues: ["select", "multioption", "autocomplete", "radio", "evaluation"],
                activatedFields: {
                    "select": {
                        required: true,
                        type: "options",
                        validation: "notEmpty",
                        label: "investigation.create.edc.choose",
                        shortLabel: "investigation.table.type"
                    },
                    "multioption": {
                        required: !this.state.forwardedFromSet,
                        type: "options",
                        validation: this.state.forwardedFromSet ? "none" : "notEmpty",
                        label: "investigation.create.edc.choose",
                        shortLabel: "investigation.table.type"
                    },
                    "autocomplete": {
                        required: true,
                        type: "options",
                        validation: "notEmpty",
                        label: "investigation.create.edc.choose",
                        shortLabel: "investigation.table.type"
                    },
                    "radio": {
                        required: true,
                        type: "options",
                        validation: "notEmpty",
                        label: "investigation.create.edc.choose",
                        shortLabel: "investigation.table.type"
                    },
                    "evaluation": {
                        required: true,
                        type: "options",
                        validation: "notEmpty",
                        label: "investigation.create.edc.choose",
                        shortLabel: "investigation.table.type"
                    }
                }
            },
            "label": {
                name: "label",
                required: false,
                type: "text",
                label: "investigation.create.edc.question_field",
                shortLabel: "investigation.table.question",
                validation: "textMin2",
                size: "s6"
            }
        }
        // When type is multioption and there are fields from previous groups,
        // show an optional "Source field" selector for forwarding.
        if (this.state.selectedType === "multioption" && this.props.previousGroupFields && this.props.previousGroupFields.length > 0) {
            FORM = {
                ...FORM,
                "forwardedFrom": {
                    name: "forwardedFrom",
                    required: false,
                    type: "select",
                    label: "investigation.create.edc.forwarded_from",
                    shortLabel: "investigation.create.edc.forwarded_from",
                    validation: "notEmpty",
                    defaultOption: { text: "investigation.create.edc.no_forwarding", value: "" },
                    options: this.props.previousGroupFields,
                    callBackOnChange: (selected) => {
                        this.setState({ ...this.state, forwardedFromSet: !!selected });
                    }
                },
                "forwardedValueKey": {
                    name: "forwardedValueKey",
                    required: false,
                    type: "select",
                    label: "investigation.create.edc.forwarded_value_key",
                    shortLabel: "investigation.create.edc.forwarded_value_key",
                    validation: "notEmpty",
                    defaultOption: { text: "multioption", value: "multioption" },
                    options: [
                        { label: "Multioption", value: "multioption" },
                        { label: "ICD Code", value: "icd-code" },
                    ]
                }
            }
        }
        if (this.state.showTextarea) {
            FORM = {
                ...FORM,
                "template": {
                    required: true,
                    type: "textarea",
                    validation: "notEmpty",
                    label: "investigation.create.edc.choose",
                    shortLabel: "investigation.table.type"
                }
            }
        }
        return FORM;
    }

    deleteField(index) {
        console.log("Delete Field", index);
        let tempState = { ...this.state };
        tempState.fields.splice(index, 1);
        this.setState(tempState);
    }

    handleAddField(values) {
        console.log("Nuevo field!", values);
        if (values.hasOwnProperty("type_options")) {
            values["options"] = values.type_options;
        }
        values.validation = isSmartField(values.type) ? "arrayOrFalse" : "notEmpty";
        let tempState = { ...this.state };
        values.order = tempState.fields.length;
        tempState.fields.push(values);
        this.setState(tempState);
        this.toogleField();
    }

    toogleField() {
        let tempState = { ...this.state };
        tempState.addingField = !tempState.addingField;
        this.setState(tempState);
    }

    closeModal() {
        let tempState = this.state;
        tempState.addingField = false;
        this.setState(tempState);
    }

    orderUpdate(dragDrop) {
        console.log("Parent reorder");
        let tempState = { ...this.state };
        const result = Array.from(tempState.fields);
        const [removed] = result.splice(dragDrop.source.index, 1);
        result.splice(dragDrop.destination.index, 0, removed);
        tempState.fields = result.map((field, index) => { field.order = index; return field; });
        this.setState(tempState);
    }

    renderFields() {
        if (this.state.fields.length > 0) {
            const FIELDS_FORM = this.getFormSection();
            const arrayHeader = Object.keys(FIELDS_FORM).map(key => {
                const value = FIELDS_FORM[key];
                return { id: key, alignment: "right", label: <Translate id={value.shortLabel} /> }
            });
            const rows = this.state.fields.sort((a, b) => a.order - b.order).map((aField, index) => {
                let tempSection = {};
                for (const keyField of Object.keys(FIELDS_FORM)) {
                    const field = FIELDS_FORM[keyField];
                    if (field.type === "checkbox") {
                        tempSection[keyField] = aField[keyField] === true;
                    } else {
                        tempSection[keyField] = aField[keyField];
                    }
                }
                tempSection["id"] = index;
                return tempSection;
            })
            return (
                <OrderableTable onDragEnd={(result) => this.orderUpdate(result)}
                    orderUpdate={(dragDrop) => this.orderUpdate(dragDrop)}
                    droppableId="droppable-field-group" noSelectable
                    titleTable={<Translate id="investigation.create.edc.fields" />}
                    headCells={arrayHeader}
                    rows={rows}
                    actions={[{ "type": "delete", "func": (index) => this.deleteField(index) }]}
                />
            )
        } else {
            return null;
        }
    }

    handleSaveFieldGroup(values) {
        console.log("handleSaveFieldGroup: " + JSON.stringify(values));
        if (this.state.fields.length === 0) {
            alert("Please add at least one field to the group");
        } else {
            let newValues = Object.assign({}, values);
            newValues.fields = [...this.state.fields];
            newValues.repeats = values.hasOwnProperty("repeats") ? values.repeats : false;
            newValues.displayMode = values.hasOwnProperty("displayMode") ? values.displayMode : "inline";
            if (newValues.repeats) {
                newValues.minRepeats = values.hasOwnProperty("minRepeats") ? values.minRepeats : undefined;
                newValues.maxRepeats = values.hasOwnProperty("maxRepeats") ? values.maxRepeats : undefined;
            }
            this.props.callBackFieldGroup(newValues);
        }
    }

    componentDidMount() {
        if (this.props.initialData) {
            console.log("Init FieldGroup Data");
            this.props.initialize(this.props.initialData);
        }
    }

    render() {
        const title = this.props.initialData ?
            <Translate id="investigation.create.edc.field_group.edit" /> :
            <Translate id="investigation.create.edc.field_group.new" />;
        const saveText = this.props.initialData ?
            <Translate id="investigation.create.edc.field_group.edit" /> :
            <Translate id="investigation.create.edc.field_group.add" />;
        const FIELDS_FORM = this.getFormSection();
        const repeatsValue = this.props.repeatsValue;

        return (
            <Grid item container xs={12}>
                <Modal id="modal-field-group"
                    open={this.state.addingField}
                    closeModal={this.toogleField}
                    title={<Translate id="investigation.create.edc.add_field" />}>
                    <Form fields={FIELDS_FORM} fullWidth callBackForm={(field) => this.handleAddField(field)}
                        closeCallBack={this.toogleField} dataTestid="save-field" />
                </Modal>
                <Grid item xs={12}>
                    <Typography variant="subtitle1" color="textPrimary">
                        {title}
                    </Typography>
                    <form onSubmit={this.props.handleSubmit(values => this.handleSaveFieldGroup(values))}>
                        <Field type="text" name="name" fullWidth label="Field Group Name" required={true} component={FieldSherwood} />
                        <Field type="text" name="description" fullWidth label="Description" component={FieldSherwood} />
                        <div>
                            <Field type="checkbox" name="repeats" label="Repeats" component={FieldSherwood} />
                        </div>
                        {repeatsValue &&
                            <>
                                <Field type="text" name="minRepeats" fullWidth label="Min Repeats" component={FieldSherwood} />
                                <Field type="text" name="maxRepeats" fullWidth label="Max Repeats" component={FieldSherwood} />
                            </>
                        }
                        <div>
                            <Field type="select" name="displayMode" label="Display Mode"
                                component={FieldSherwood}
                                defaultOption={FIELD_GROUP_FORM.displayMode.defaultOption}
                                options={FIELD_GROUP_FORM.displayMode.options} />
                        </div>
                        <div style={{ paddingTop: "40px" }}>
                            <Typography variant="body2" color="textPrimary" component="span">
                                <Translate id="investigation.create.edc.add_field" />
                            </Typography>
                            <ButtonAdd type="button" data-testid="add-field" onClick={this.toogleField}
                                show={true}>
                            </ButtonAdd>
                        </div>
                        {this.renderFields()}
                        <div style={{ paddingTop: "40px" }}>
                            <ButtonSave disabled={this.state.fields.length === 0} data-testid="save-field-group" type="submit">
                                {saveText}
                            </ButtonSave>
                            <ButtonCancel onClick={this.props.closeFieldGroup} data-testid="cancel-field-group"
                                style={{ marginLeft: '1rem' }} type="button">Cancel</ButtonCancel>
                        </div>
                    </form>
                </Grid>
            </Grid>
        )
    }
}

function validate(values) {
    const errors = {};
    Object.keys(FIELD_GROUP_FORM).forEach(key => {
        const validation = validateField({ value: values[key], validation: FIELD_GROUP_FORM[key].validation, required: FIELD_GROUP_FORM[key].required })
        if (!validation.result) {
            errors[key] = validation.messageCode;
        }
    });
    return errors;
}

FieldGroup.propTypes = {
    initialData: PropTypes.object,
    callBackFieldGroup: PropTypes.func.isRequired,
    closeFieldGroup: PropTypes.func.isRequired,
    repeatsValue: PropTypes.bool,
    previousGroupFields: PropTypes.array
};

const FieldGroupForm = reduxForm({
    validate: validate,
    form: 'field_group'
})(FieldGroup);

const selector = formValueSelector('field_group');
const ConnectedFieldGroup = connect(state => ({
    repeatsValue: selector(state, 'repeats')
}))(FieldGroupForm);

export default withLocalize(ConnectedFieldGroup)
